import Vue from "vue";
import VueI18n from "vue-i18n";
import messages from "./messages";

Vue.use(VueI18n);

const getInitialLocale = () => {
  const browserLang = (navigator.languages && navigator.languages[0]) || navigator.language || "";
  const lang = String(browserLang).toLowerCase();
  if (lang.startsWith("zh")) return "ft";
  if (lang.startsWith("en")) return "en";
  return "en";
};

const i18n = new VueI18n({
  locale: getInitialLocale(),
  fallbackLocale: "en",
  messages,
  silentFallbackWarn: true,
});

export default i18n;





// WEBPACK FOOTER //
// ./src/i18n/index.js